import React from "react";
import NewDocument from "../../components/document/NewDocument";
import { UnauthorizedError } from "../../components/generic/UnauthorizedError";
import { ProtectedComponent } from "../../components/wrappers/ProtectedComponent";
import { UserFunctionEnum } from "../../api/models/user-function-enum";

export const NewDocumentPage: React.FunctionComponent = () => {
  return (
    <ProtectedComponent userFunction={UserFunctionEnum.MENU_NEW_DOCUMENT} errorComponent={<UnauthorizedError />}>
      <NewDocument />
    </ProtectedComponent>
  );
};
